import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../shared/models/user';
import {SessionService} from '../../shared/services/session.service';
import {Subscription} from 'rxjs/internal/Subscription';
import {UserService} from '../../shared/services/user.service';
import {CartService} from '../../shared/services/cart.service';
import {NotificationService} from '../../shared/services/notification.service';
import {MatTableDataSource} from '@angular/material/table';
import {CouponService} from '../../shared/services/coupon.service';

@Component({
  selector: 'mbnm-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent implements OnInit, OnDestroy {

  private userChangedSubscription:Subscription;
  coupons:MatTableDataSource<any>;

  constructor(private userService: UserService,
              private cartService: CartService,
              private notificationService: NotificationService,
              private couponService: CouponService) { }

  ngOnInit() {
    this.userChangedSubscription = SessionService.currentUserChanged.subscribe(async (currentUser:User) => {
      this.coupons = new MatTableDataSource(await this.couponService.getUserCoupons());
    });
  }

  ngOnDestroy() {
    if (this.userChangedSubscription && !this.userChangedSubscription.closed) {
      this.userChangedSubscription.unsubscribe();
    }
  }

  async applyCoupon(coupon:any) {
    coupon.applying = true;
    try {
      await this.couponService.applyToCart(coupon.Code);
      this.notificationService.createNotification('Coupon code applied to your shopping cart!', 'success', 5000);

    } catch (err) {
      this.notificationService.createNotification('There was an error applying your coupon code. Please try again.', 'error', 5000);
    } finally {
      coupon.applying = false;
    }
  }
}
